<div class="max-w-3xl mx-auto px-4 py-6">
  <!-- Order summary -->
  <div class="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
    <div class="px-5 py-4 border-b border-gray-100">
      <h5 class="font-semibold text-gray-800">
        {{ textService.get("payment.title") | async }}
      </h5>
    </div>
    <div class="divide-y divide-gray-100">
      @for (orderLine of cartStore.articles(); track orderLine) {
        <div class="px-5 py-3">
          <div class="flex items-center">
            <span class="flex-1 text-sm text-gray-800">{{
              orderLine.product.description
            }}</span>
            <span class="text-sm text-gray-700">{{
              orderLine.price | ttcurrency
            }}</span>
          </div>
          <div class="flex items-center gap-1 mt-1.5">
            <tt-button
              variant="outline"
              (clicked)="decrement(orderLine.generatedId)"
              >−</tt-button
            >
            <span class="w-8 text-center text-sm font-medium">{{
              orderLine.quantity
            }}</span>
            <tt-button
              variant="outline"
              (clicked)="increment(orderLine.generatedId)"
              >+</tt-button
            >
          </div>
        </div>
        @for (
          questionDetail of orderLine.questionDetails | keyvalue;
          track questionDetail
        ) {
          <div class="flex px-5 py-1.5">
            <span class="flex-1 text-xs text-gray-500 pl-2"
              >− {{ questionDetail.value.description }}</span
            >
            @if (questionDetail.value.price > 0) {
              <span class="text-xs text-gray-500"
                >+{{ questionDetail.value.price | ttcurrency }}</span
              >
            }
          </div>
        }
      }
      @for (extraLine of getExtraCostsifNotFree(); track extraLine) {
        <div class="flex px-5 py-3">
          <span class="flex-1 text-sm text-gray-700">{{
            extraLine.description
          }}</span>
          <span class="text-sm text-gray-700">{{
            extraLine.price | ttcurrency
          }}</span>
        </div>
      }
      <div class="flex px-5 py-4 font-semibold">
        <span class="flex-1 text-gray-800">{{
          textService.get("payment.table_total") | async
        }}</span>
        <span class="text-gray-900">{{ getGrandTotal() | ttcurrency }}</span>
      </div>
    </div>
  </div>

  <form [formGroup]="form">
    <!-- Tip section -->
    @if (tip.enabled) {
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
        <div class="px-5 py-4 border-b border-gray-100">
          <h5 class="font-semibold text-gray-800">
            {{ textService.get("payment.tip") | async }}
          </h5>
        </div>
        <div class="px-5 py-4 space-y-3">
          <p class="text-sm text-gray-600">
            {{ textService.get("payment.tip_text_above") | async }}
          </p>
          <div class="flex flex-wrap gap-2">
            @for (amount of getFeeAmounts(); track amount) {
              <tt-button variant="secondary" (clicked)="setTip(amount)">{{
                amount | ttcurrency
              }}</tt-button>
            }
            <tt-button
              variant="secondary"
              (clicked)="showOtherAmount = !showOtherAmount"
            >
              {{ textService.get("payment.tip_other_amount_button") | async }}
            </tt-button>
          </div>
          @if (showOtherAmount) {
            <div>
              <p class="text-sm text-gray-600 mb-1">
                {{ textService.get("payment.tip_choose_amount") | async }}
              </p>
              <input
                formControlName="tip"
                min="0"
                value="0"
                (change)="onChangeTip()"
                class="w-40 border border-gray-300 rounded-lg px-3 py-2 text-sm"
              />
            </div>
          }
        </div>
      </div>
    }

    <!-- Payment methods -->
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 mb-6">
      <div class="px-5 py-4 border-b border-gray-100">
        <h5 class="font-semibold text-gray-800">
          {{ textService.get("payment.title2") | async }}
        </h5>
      </div>
      <div class="px-3 py-4">
        <tt-option-group
          formControlName="method"
          [options]="getPaymentMethodOptions()"
          (valueChange)="onSelectPaymentMethod()"
        />
      </div>
    </div>

    <!-- Fixed confirm button -->
    <div class="fixed bottom-4 right-4 z-20">
      <tt-button
        variant="primary"
        (clicked)="confirmPayment()"
        [disabled]="!shouldEnableActionButtons()"
      >
        {{ textService.get("payment.confirm") | async }}
      </tt-button>
    </div>
  </form>
</div>
